//https://www.jsmount.com/how-to-create-a-common-helper-class-or-util-file-in-react-js/
class T {
	// static test(){
	//     return ["SS","EE","FF","GGG"];
	// }
	//0 to n-1
	static roundToTwo(num) {
		return +(Math.round(num + "e+2") + "e-2");
		//parseFloat(props.value/props.weight).toFixed(2);
	}
	static roundToFix(num,n) {
		return parseFloat(num).toFixed(n);
	}
	static str_toListInt(a, splitter) {
		//https://stackoverflow.com/questions/15677869/how-to-convert-a-string-of-numbers-to-an-array-of-numbers
		var s = ",";
		if (splitter != null) {
			s = splitter;
		}
		// console.log("sss " + s);
		return Array.from(a.split(s), Number);
	}
	static str_LinestoListInt(a, allowNaN) {
		if (allowNaN == null) {
			allowNaN = true;
		}
		var list = [];
		const arr = a.split("\n");
		for (const b of arr) {
			if (b != "") {
				let x = parseInt(b);
				if (allowNaN || !isNaN(x)) {
					list.push(x);
				}
			}
		}
		return list;
	}
	static isNaN(x) {
		return x !== x;
	}
	static arr_getMean(arr) {
		var sum = 0;
		for (var number of arr) {
			sum += number;
		}
		var average = sum / arr.length;
		return average;
	}

	static listSort(list) {
		//https://stackoverflow.com/questions/43572436/sort-an-array-of-objects-in-react-and-render-them
		return list.sort((a, b) => a - b);
	}
	static listSort_desc(list) {
		return list.sort((a, b) => b - a);
	}
	static listInt_printX(list) {
		//2,1,1 >> 2,1x2
		return list.sort((a, b) => b - a);
	}
	static arr_max(array) {
		return Math.max.apply(Math, array);
	}
	static getMatrix(r, c) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).map(() => new Array(c));
	}
	static getMatrix(r, c, v) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).fill(v).map(() => new Array(c).fill(v));
	}
	static getMatrix_empty(r, c) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).map(() => new Array(c));
	}
	static listPrint(r, c, v) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).fill(v).map(() => new Array(c).fill(v));
	}
	static listPrint_splitSpaceEveryN(list, splitter, n) {
		//1,1,1,1,1,1,1,1,1,1,1,1 >> 1,1,1, 1,1,1, 1,1,1, 1,1,1
		var output = "";
		var arr = list.split(splitter);
		for (var i = 0; i < arr.length; i++) {
			if (output != "") {
				output += splitter;
				if (i % n == 0) {
					output += " ";
				}
			}
			output += arr[i];
		}
		return output;
	}
	static listAdd(list, x) {
		var list_new = list.slice();
		list_new.push(x);
		return list_new;
	}
	static getValue(x, d) {
		//get from gui or whatever, if not null > if null, use default d
		var a = x;
		if (a == null) {
			a = d;
		}
		return a;
	}
	static strReverse(str) {
		return str.split("").reverse().join("");
	}
	static arr_getDiff(arr1, arr2) {
		//2-1
		var arr_output = [arr1.length];
		for (var i = 0; i < arr1.length; i++) {
			arr_output.push(arr2[i] - arr1[i]);
		}
		return arr_output;
	}
	//====================================
	static obj_print(obj) {
		//e.g., { id:1 v:2}
		return JSON.stringify(obj, null, 4);
	}
	static log_obj(obj1) {
		console.log(JSON.stringify(obj1, null, 4));
	}
	static log_obj2(pretxt, obj1, posttxt) {
		console.log(pretxt + JSON.stringify(obj1, null, 4) + posttxt);
	}
	static arr_countTrue(arr) {
		return arr.filter(Boolean).length;
	}
	static deci_toPercent(num) {
		//console.log(formatAsPercent(25.49));  >> 25%
		return new Intl.NumberFormat("default", {
			style: "percent",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(num / 100);
	}
}
export default T;
